import styled from 'styled-components'
import fondo from '../../imgs/fondomenu.avif'
import fondoJuegos from '../../imgs/videojuegos.jpg'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Button from '@mui/material/Button';
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { user,userLogin } from '../../redux/actions/loginActions.js';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import { loginUser } from '../../services/login.js'


const ContainerBackdrop=styled.div`
 	display:flex;
 	height:100vh;
 	z-index:1;
 	display:flex;
 	
`;
const Container2=styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	height:100vh;
	width:0px;
	transition: all 400ms;
	position:relative;	
	background-color:white;
	box-Shadow:0 10px 20px 5px rgba(0,0,0,0.1); 
	z-index:1;
 	
`;

const Overlay=styled.div`
	position:absolute;
	background-image:url(${fondoJuegos});
	background-size:98%;
	background-position:center;
	height:100%;
	width:100%;
	min-height:500px
	
`;

const Overlay2=styled.div`
	position:absolute;
	background-image:url(${fondo});
	background-size:100%;
	background-position:center;
	height:100%;
	width:100%;
	z-index:-1;
	opacity:0.08;
	
	
`;


const ContainerIngresar=styled.form`
	display:flex;
	justify-content:space-around;
	align-items:center;
	margin:35px;
	width:65%;


`;

const CrearCuenta=styled.div`
	font-size:9px;
	color:blue;
	width:65%;
	display:flex;
	justify-content:end;
	&:hover{
		cursor:pointer
	}

`;

const ContainerLogeo=styled.div`
	
	z-index:1;
	display:flex;	
	flex-direction:column;
	align-items:center;
	justify-content: space-around;
	height:70vh;	
	width:50%;
	min-width:0px;
	background-color: white;
	filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3));
	border-radius:25px;
	overflow:hidden;
	min-height:600px

`;

const Backdrop=styled.div`
	width:0vw;
	height:100%;
	background-color:black;
	opacity:0.5;
	transition: all 400ms;
`;

const Marca=styled.div`
	position:absolute;
	right:50px;
	bottom:25px;
	z-index:2;
	font-size:14px;
	color:white

`;


export default function BackDropLoginPrincipal(props){
	let { open,close } = props;
	let [datos,setDatos]=useState({usuario:"",password:""});
	let dispatch=useDispatch();
	let navigate=useNavigate();
	const [showPassword, setShowPassword] = useState(false);





	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => { event.preventDefault() };
		
	const handleKeyPress = (e) => {
    		if (e.key === 'Enter') {
      				validar();
    		}
  	};


	

	let cancelar=()=>{
		console.log("close");
		close(false)
	};

	let validar=async()=>{
		try{
			let validate=await loginUser(datos);
					dispatch(user(validate));
					dispatch(userLogin(true));
					alert(`bienvenido ${datos.usuario}`)

			switch(validate.tipo){
				case 1:					
					navigate("/Home/solicitudes");
					break
				case 2:
					navigate("/Home/solicitudes");
					break
				default:
					close(false);
			}
		}catch(err){alert(err)}
	};

	let handleChange=(e)=>{
		setDatos({...datos,[e.target.id]:e.target.value.trim() })
	};

	return(
			<ContainerBackdrop>
				<Backdrop style={{width:open?"65vw":"0px"}}/>
				<Container2 style={{width:open?"35vw":"0px",minWidth:open?"420px":"0px"}}>
				<Overlay/>
				
				<ContainerLogeo style={{minWidth:open?"250px":"0px"}}>
					<Overlay2/>
					<AccountCircle  style={{ fontSize: open?70:0,margin:10,backgroundColor:"white" }} />
					<TextField  label="usuario" variant="standard" id="usuario" style={{width:"70%"}} onChange={handleChange}   size="small" />	
				
					<FormControl  style={{width:"70%"}}  size="small" onSubmit={validar}>
						<InputLabel >Password</InputLabel>
          				<Input id="password" onChange={handleChange} onKeyPress={handleKeyPress} label="Password" type={showPassword ? 'text' : 'password'}  
          					endAdornment={
          						<InputAdornment position="end">
          							<IconButton   onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                  						{showPassword ? <VisibilityOff /> : <Visibility />}
                					</IconButton>
              					</InputAdornment>
            			}
            			/>
          			</FormControl>
          			<CrearCuenta ><span onClick={()=>navigate("/registro")}>crear una cuenta</span></CrearCuenta>
          			<ContainerIngresar>
          				<Button onClick={validar} variant="contained" color="success"  size="small">ingresar</Button>
          				<Button   size="small" variant="contained" color="error" onClick={cancelar}>cancelar</Button>
          			</ContainerIngresar>
				</ContainerLogeo>
			</Container2>

			{open?<Marca><b>Playlan</b>mym™</Marca>:null}
			
					
			</ContainerBackdrop>

		)
}